import { Empty, Typography } from 'antd'

import { useViewAs } from '../contexts/viewAs'

// For admins, the cabinet has no data until an investor is chosen in the header
// "Viewing For" picker. Render a prompt instead of the data pages (which would
// otherwise 401 with no impersonation target). Non-admins pass through untouched.
const CabinetGate = ({ children }) => {
	const { isAdmin, viewAs } = useViewAs()

	if (isAdmin && !viewAs) {
		return (
			<div style={{ padding: '80px 24px', display: 'flex', justifyContent: 'center' }}>
				<Empty
					description={
						<Typography.Text type='secondary'>
							Select an investor in “Viewing For” above to view their cabinet
						</Typography.Text>
					}
				/>
			</div>
		)
	}

	return children
}

export default CabinetGate
